export default __webpack_public_path__ + "static/media/85c7411b9cef1d470fb3af85e44cc047.069ba009.svg";